<template>
  <div class="">
    <!--  <div class="title" style=" margin-bottom:10px" id="title">
            <span style="margin-right: 135px;" >仓库：{{user.coutstockorgid}}</span>
            <span>库管员：{{user.user_name}}</span>
        </div> -->
    <!-- <div class="line"></div> -->
    <div class="condition clearfix" id="topinp" style="">
      <el-form :inline="true" :model="conditions" class="demo-form-inline clearfix" :rules="rules" ref="conditions">
        <div class="clearfix">
          <el-form-item class="tinp" label="调出货位：" prop="houtpositionname">
            <el-select @change="selectchange1" filterable value-key="positioncode" v-model="conditions.houtpositionname" placeholder="请选择调出货位" style="width:100%;" auto-complete="off">
              <el-option v-for="item in positionList" :key="item.positioncode" :label="item.positionname" :value="item"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="tinp" label="调入货位：" prop="hinpositionname">
            <el-select @change="selectchange2" filterable value-key="positioncode" v-model="conditions.hinpositionname" placeholder="请选择调入货位" style="width:100%;" auto-complete="off">
              <el-option v-for="item in positionList" :key="item.positioncode" :label="item.positionname" :value="item"></el-option>
            </el-select>
          </el-form-item>
          <!--   <el-form-item label="调整日期：" prop="dcountdate" class="tinp">
                    <el-date-picker v-model="conditions.dcountdate" type="date" placeholder="选择日期" @change="onParamChange">
                    </el-date-picker>
                </el-form-item> -->
          <el-form-item label="备注：" class="tinp beizhu" style="width:503x">
            <el-input v-model="conditions.vnote" placeholder="请输入备注信息" prefix-icon="el-icon-edit" clearable @change="onParamChange"></el-input>
          </el-form-item>
          <br>
          <el-form-item class="fr">
            <!--    -->
            <el-button type="primary" class="" @click="exportPresentSock" style="margin:0 10px 10px" icon="el-icon-printer" v-loading.fullscreen.lock="fullscreenLoading">导出</el-button>
            <el-button type="primary" class="" @click="submit('conditions')"  v-loading.fullscreen.lock="fullscreenLoading">确认提交</el-button>
          </el-form-item>
          <el-form-item class="fr">
            <el-button size="small" type="primary" style="width:40px;height: 38px" icon="el-icon-plus" @click="addList"></el-button>
          </el-form-item>
        </div>
        <div class="tablebox" style="margin-top: 0;">
          <table style="width:100%">
            <tr style="border: 1px solid #56B8AA;background: #56B8AA;color: #fff;height:45px">
              <th style="width: 234px !important">商品名称</th>
              <!--  <th style="width: 100px !important" >出</th>
                                    <th style="width: 100px !important" >入</th> -->
              <th style="width: 115px !important">商品编码</th>
              <!-- <th style="width: 115px !important">供应商</th> -->
              <th style="width: 115px !important">规格</th>
              <th style="width: 117px !important">型号</th>
              <th style="width: 94px !important">单位</th>
              <th style="width: 93px !important">数量</th>
              <th style="width: 184px !important">备注</th>
              <th style="width:58px">删除</th>
            </tr>
          </table>
          <div style="overflow-y: auto;height:654px">
            <table style="width:100%" id="tablescroll2">
              <tr v-for="(item,index) in conditions.productList" :key="index">
                <td style="border: 1px solid #56B8AA; height: 38px;width:246px">
                  <el-input style="width: 100%" class="tabinp" placeholder="选择商品" suffix-icon="el-icon-search" v-model="item.materialname" @change="onParamChange" v-on:click.native="oppro(index)">
                  </el-input>
                </td>
                <td v-for="head in tableHeads" style="border: 1px solid #56B8AA; height: 38px;width:120px">
                  <el-input class="tabinp" v-model="item[head.key]" clearable @change="onParamChange"></el-input>
                </td>
                <td style="border: 1px solid #56B8AA; height: 38px;width:100px">
                  <el-input class="tabinp" v-model="item.cunitname" clearable @change="onParamChange"></el-input>
                </td>
                <td style="border: 1px solid #56B8AA; height: 38px;width:100px">
                  <el-input class="tabinp" type="number" v-model="item.nnum" clearable @blur="numdown(item.nnum)"></el-input>
                </td>
                <td style="border: 1px solid #56B8AA; height: 38px;width:189px">
                  <el-input class="tabinp" v-model="item.memo" clearable @change="onParamChange"></el-input>
                </td>
                <!--  <td v-for="head in tableHeads" style="border: 1px solid #56B8AA; height: 38px;width:15%" >
                                    <el-input class="tabinp" v-model="item[head.key]" clearable @change="onParamChange"></el-input>
                                </td> -->
                <td style="border: 1px solid #56B8AA;width:60px;">
                  <el-button v-if="conditions.productList.length>1" type="danger" class="" size="small" @click="dellist(index,item.vbillcode)">删行</el-button>
                  <el-button v-else disabled="disabled" type="danger" class="" size="small"  @click="dellist(index,item.vbillcode)">删行</el-button>
                </td>
              </tr>
            </table>
          </div>
        </div>
      </el-form>
    </div>
    <!-- model start -->
    <div class="model" v-show="modelShow2">
      <div class="content">
        <div class="title">
          <span class="fl">请选择商品</span>
          <span class="fr" @click="closemodel(2)"><i class="iconfont icon-guanbi"></i></span>
        </div>
        <div class="procontent clearfix" style="padding: 0 20px">
          <el-form :inline="true" class="demo-form-inline">
            <el-form-item label="商品编码：" class="tinp">
              <el-input v-model="serchpro.productCode" suffix-icon="el-icon-search" @keyup.enter.native="selectProduct(index)" clearable @change="selectProduct(index)"></el-input>
            </el-form-item>
            <el-form-item label="商品名称：" class="tinp">
              <el-input v-model="serchpro.productName" suffix-icon="el-icon-search" @keyup.enter.native="selectProduct(index)" clearable @change="selectProduct(index)"></el-input>
            </el-form-item>
            <el-button type="primary" class="" size="small" icon="el-icon-search" @click="selectProduct(index)">搜索</el-button>
          </el-form>  
            <div class="clearfix"  style="border: 1px solid #56B8AA;background: #56B8AA;color: #fff;height:45px;width:1080px;margin:0">
                <div class="fl" style="width:62px;height:45px;line-height: 45px;text-align:center;">选择</div>
                <div class="fl" style="width:213px;height:45px;line-height: 45px;text-align:center;">商品编码</div>
                <div class="fl" style="width:406px;height:45px;line-height: 45px;text-align:center;">商品名称</div>
                <div class="fl" style="width:133px;height:45px;line-height: 45px;text-align:center;">规格</div>
                <div class="fl" style="width:133px;height:45px;line-height: 45px;text-align:center;">型号</div> 
                <!-- <div class="fl" style="width:214px;height:45px;line-height: 45px;text-align:center;">供应商</div> -->
                <div class="fl" style="width:133px;height:45px;line-height: 45px;text-align:center;">单位</div> 

            </div>
          <div class="productList" style="overflow-y: auto;overflow-x:hidden;width:1098px;height: auto;max-height:332px">
            <table style="width:1081px">
              <!-- <tr style="border: 1px solid #56B8AA;background: #56B8AA;color: #fff;height:45px">
                <th style="border: 1px solid #56B8AA;">选择</th>
                <th style="" v-for="head in proTitle">{{ head.label }}</th>
              </tr> -->
              <tr v-for="(item,index) in productList2" :id="index" :key="index">
                <td class="fir" style="color: #fff;border: 1px solid #56B8AA;width:62px;">
                  <div class="list-item-check">
                    <span class="checkbox-btn item-check-btn" v-bind:class="{'checked':item.checked=='1'}" @click="choose2(index)">
                            <span class="iconfont icon-duigou" style="font-size: 12px"></span>
                    </span>
                  </div>
                </td>
                <td style="border: 1px solid #56B8AA;width:213px; height: 38px" @click="choose2(index)">
                  {{item.materialcode}}
                </td>
                <td style="border: 1px solid #56B8AA;width:406px; height: 38px" @click="choose2(index)">
                  {{item.materialname}}
                </td> 
                <td style="border: 1px solid #56B8AA;width:133px; height: 38px" @click="choose2(index)">
                  {{item.wlspec}}
                </td>
                <td style="border: 1px solid #56B8AA;width:133px; height: 38px" @click="choose2(index)">
                  {{item.wltype}}
                </td>
                <!--  <td style="border: 1px solid #56B8AA;width:214px; height: 38px" @click="choose2(index)">
                  {{item.suppliername}}
                </td> -->
                <td style="border: 1px solid #56B8AA;width:133px; height: 38px" @click="choose2(index)">
                  {{item.cunitname}}
                </td>
              </tr>
            </table>
          </div>
          <el-button type="primary" class="fr" size="small" style="margin-top: 10px" @click="checkpro2">确定</el-button>
        </div>
 <!-- fenye start -->
        <div class="block" style="text-align: center;margin:0px auto ">
          <span>
            <el-pagination class="fenye" @size-change="handleSizeChange" @current-change="handleCurrentChange"  background
              :current-page="propage"
              :page-size="prosize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="procount">
            </el-pagination>
            </span>
        </div>
        <!-- fenye end -->
      </div>
    </div>
    <!-- model start -->
    <!-- model start -->
    <div class="model selectmodel" v-show="modelShow">
      <div class="content">
        <div class="title">
          <span class="fl">选择货位</span>
          <span class="fr" @click="closemodel(1)"><i class="iconfont icon-guanbi"></i></span>
        </div>
        <div class="selectinput">
          <el-form :inline="true" style="padding:10px">
            <el-form-item v-if="selectid =='1'" class="" style="width:100%;margin: 0 !important">
              <el-select v-model="outposition.position_name" value-key="position_code" clearable placeholder="请选择调出货位" style="width:100%;" auto-complete="off" @change="selectchange">
                <el-option v-for="item in positionList" :key="item.position_code" :label="item.position_name" :value="item"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item v-else-if="selectid =='2'" class="" style="width:100%;margin: 0 !important">
              <el-select @change="selectchange" value-key="position_code" v-model="inposition.position_name" clearable placeholder="请选择调入货位" style="width:100%;" auto-complete="off">
                <el-option v-for="item in positionList" :key="item.position_code" :label="item.position_name" :value="item"></el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
    <!-- model end -->
    <!-- model end -->
    <div class="" v-show="fullscreenLoading"></div>
    <!-- 弹窗 start --> 
    <MessageModel types="提示信息" :msg="msg" :msgShow="msgShow" :flag="modelFlag" :butmsg="butmsg" :butflag = "butflag" @modelmsg="returnMsg"></MessageModel> 
  </div>
</template>
<script>
// import MessageModel from '../../components/MessageModel'
export default {
  name: '',
  data() {
    var validateHoutposition = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请选择调出货位'));
      } else {
        callback();
      }
    };
    var validateHinposition = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请选择调入货位'));
      } else {
        callback();
      }
    };
    return {
      flag:false,
      msgShow:false,
      modelFlag:false,
      modelFlag2:false,
      butflag:true,
      butflag2:true,
      msg:'', 
      butmsg:'确认', 
      butmsg2:'确认', 
      methodName:'',
      utilpath: '',
      falg: false,
      modelShow: false,
      modelShow2: false,
      fullscreenLoading: false,
      productName: '',
      productCode: '',
      serchpro: {
        storecode: '',
        productName: '',
        productCode: '',
        hinpositioncode:'',
        hinpositionname:'',
        houtpositioncode:'',
        houtpositionname:'',
        flag:'',
        pageflag:0,
      },
      hinpositioncode:'',
      hinpositionname:'',
      houtpositioncode:'',
      houtpositionname:'',
      positioncodes:'',
      productList2: [],
      proTitle: [{
          label: '商品编码',
          key: 'materialcode'
        },
        {
          label: '商品名称',
          key: 'materialname'
        },
        {
          label: '规格',
          key: 'wlspec'
        },
        {
          label: '型号',
          key: 'wltype'
        }, 
        // {
        //   label: '供应商',
        //   key: 'suppliername'
        // }, 
        // {
        //   label: '单价',
        //   key: 'nprice'
        // },
        {
          label: '单位',
          key: 'cunitname'
        }
      ],
      user: {},
      delindex:'',
      index: '',
      index2: '',
      index2List: [],
      selectid: '1',
      tableListindex: 0,
      outposition: {
        position_code: '', //调出货位编码
        position_name: '' //调出货位名称
      },
      inposition: {
        position_code: '', //调入货位编码
        position_name: '', //调入货位名称
      },
      positionList: [],
      positioncodes:'',
      conditions: {
        corpcode:'',//组织编码
        corpname:'',//组织名称 
        storeCode:'', 
        storeName:'',
        repertorycode:'', 
        repertoryname:'',
        dcountdate: '', //调整时间
        billmakercode: '',
        billmakername: '',
        houtpositioncode: '',
        houtpositionname: '',
        hinpositioncode: '',
        hinpositionname: '',
        vnote: '', //备注
        productList: [{
          cinrepertorycode: '',//调入仓库编码
          cinrepertoryname: '',//调入仓库名称
          hinpositioncode: '', //调入货位编码
          hinpositionname: '', //调入货位名称                   
          houtpositioncode: '', //调出货位编码
          houtpositionname: '', //调出货位名称
          materialcode: '', //物料编码
          materialname: '', //物料名称
          suppliercode: '', //供应商编码
          suppliername: '', //供应商名称
          // wlspec: '',//规格
          // wltype: '',//型号
          cunitname: '', //主单位
          // vbatchcode: '',//批次号
          nnum: '', //调出数量
          memo:''
        }]
      },
      tableHeads: [
        // {
        //     label: '调出货位',
        //     key: 'houtpositionname'
        // },
        // {
        //     label: '调入货位',
        //     key: 'hinpositionname'
        // },
        // {
        //     label: '商品名称',
        //     key: 'materialname'
        // },
        {
          label: '商品编码',
          key: 'materialcode'
        }, 
        // {
        //   label: '供应商',
        //   key: 'suppliername'
        // },
        {
          label: '规格',
          key: 'wlspec'
        },
        {
          label: '型号',
          key: 'wltype'
        }, 
        // {
        //   label: '供应商',
        //   key: 'suppliername'
        // },
        // {
        //     label: '主单位',
        //     key: 'cunitid'
        // },
        // {
        //     label: '批次号',
        //     key: 'vbatchcode'
        // },
        // {
        //     label: '调整数量',
        //     key: 'outnum'
        // }, 
        // {
        //     label: '备注',
        //     key: 'memo'
        // }
      ],
       propage:1,
      prosize:20,
      procount:0,
      rules: { //规则
        houtpositionname: [
          { required: true, validator: validateHoutposition, trigger: 'blur' }
        ],
        hinpositionname: [
          { required: true, validator: validateHinposition, trigger: 'blur' }
        ]
      }
    }
  },
  mounted() {
    // 获取接口名
    this.InterfacePath = window.localStorage.getItem("InterfacePath");
    this.utilpath = this.axios.defaults.baseURL;
    this.init();
  },
  destroyed() {
    sessionStorage.removeItem("weilist");
    sessionStorage.removeItem("productList2");
  },
  methods: {
    exportPresentSock() {  
      require.ensure([], () => {
        var { export_json_to_excel } = require('../../vendor/Export2Excel');
        var tHeader = ['商品名称', '商品编码', '供应商', '规格', '型号', '单位', '数量', '备注'];
        var filterVal = ['materialname','materialcode','suppliername',  'wlspec', 'wltype', 'cunitname', 'nnum', 'memo'];
        var list = JSON.parse(JSON.stringify(this.conditions.productList));
        var data = this.formatJson(filterVal, list);
        export_json_to_excel(tHeader, data, '货位调整单');
      })
    },
    formatJson(filterVal, jsonData) {
                return jsonData.map(v => filterVal.map(j => v[j]))
    },
    returnMsg(flag){ 
      this.modelFlag = false;
      if(flag){
            // console.log("---进来了！！！----"+this.methodName);
            if(this.methodName == 'delRow'){
              console.log("11111进来删除，查看子表条数"+this.conditions.productList.length);
                if (this.conditions.productList.length > 1) {
                  this.conditions.productList.splice(this.delindex, 1);
                }
                sessionStorage.setItem("weilist", JSON.stringify(this.conditions));
            }else if(this.methodName == 'tiwei'){
                  this.fullscreenLoading = true;
                 // console.log("111222333进来了！！！！！！");
                  //接口
                  var reqParams = {
                    billadjustment: JSON.stringify(this.conditions),
                  };
                  this.$http.post(this.utilpath + '/insertBilladjustment', reqParams, { emulateJSON: true,_timeout:600 }).then((res) => {
                    // this.$http.post('/ktnapi/insertBilladjustment', reqParams,{emulateJSON:true}).then((res) => {
                    // this.$http.post(this.InterfacePath+'/insertBilladjustment', reqParams,{emulateJSON:true}).then((res) => {
                    if (res.data.status == '0') {
                      this.fullscreenLoading = false; 
                      this.conditions = {
                        corpcode:this.user.corpcode,
                        corpname:this.user.corpname,
                        storeCode:this.user.storecode,
                        storeName: this.user.storename,
                        repertorycode:this.user.storehouse_code,
                        repertoryname:this.user.storehouse_name,
                        billmakercode: this.user.user_code, //制单人
                        billmakername: this.user.user_name, //制单人
                        dcountdate: '', //调整时间
                        outpositioncode: '',
                        outpositionname: '',
                        inpositioncode: '',
                        inpositionname: '',
                        vnote: '', //备注
                        productList: [{
                          cinrepertorycode: this.user.storehouse_code,
                          cinrepertoryname: this.user.storehouse_name,
                          hinpositioncode: '', //调入货位编码
                          hinpositionname: '', //调入货位名称                   
                          houtpositioncode: '', //调出货位编码
                          houtpositionname: '', //调出货位名称
                          materialcode: '', //物料编码
                          materialname: '', //物料名称
                          suppliercode: '', //供应商编码
                          suppliername: '', //供应商名称
                          // wlspec: '',//规格
                          // wltype: '',//型号
                          cunitname: '', //主单位
                          // vbatchcode: '',//批次号
                          nnum: '', //调出数量
                          memo:''
                        }]
                      };
                      this.index2List=[];
                      this.$message({
                        showClose: true,
                        message: '提交成功！',
                        type: 'succcess'
                      });

                    } else if(res.data.status == '9'){
                            this.$router.push({path:'/ui/login',query:{msg:9}});
                    } else {
                      this.fullscreenLoading = false;
                      this.modelFlag = true;
                      this.msgShow = true;
                      this.methodName = 'message';
                      this.msg = res.data.message;
                      this.butflag =false;
                      this.butmsg='知道了';
                      // this.$alert(res.data.message, '失败信息', {
                      //   confirmButtonText: '确定'
                      // });
                    };
                  }, (err) => {
                      this.fullscreenLoading = false;
                      this.modelFlag = true;
                      this.msgShow =false;
                      this.methodName = 'message';
                      this.msg = "连接提交货位调整单接口失败！" + err;
                      this.butflag =false;
                      this.butmsg='知道了';
                    // this.$alert("连接提交货位调整单接口失败！" + err, '失败信息', {
                    //   confirmButtonText: '确定'
                    // });
                    console.log('error submit!!' + err);
                  });


            }
      }else{
        this.fullscreenLoading=false;
        this.$message({
          showClose:true,
          message:'已取消',
          type:'succcess'
        })
      }
    }, 
    returnMsg2(flag) {

      this.modelFlag = false;
      
       if (flag) {
      //  console.log("---进来了！！！----" + this.methodName);
        if (this.methodName == 'message') {

        } 
      }
    }, 
    openselectmodel(index, num) {
     // console.log("model内打印：" + index);
      this.tableListindex = index;
      this.selectid = num;
      this.modelShow = true;
    },
    closemodel(num) {
      if (num == '1') {

        this.modelShow = false;
      } else {

        this.modelShow2 = false;
        this.index = '';
        this.index2 = '';
        for(var g=0;g<this.productList2.length;g++){
          this.productList2[g].checked=='0'
          document.getElementById(g).style.backgroundColor = "#fff"
        }
      }
    },
     handleSizeChange(val) {
    //  console.log(`每页 ${val} 条`);
      this.prosize = val;
      this.propage=1; 
      // this.selectProduct();
     // console.log(this.prosize);
    },
    handleCurrentChange(val) {
     // console.log(`当前页: ${val}`);
      this.propage = val;
    //  console.log(this.propage); 
      // this.fullscreenLoading=true;
      this.selectProduct();
    },
    selectchange1(value) {
     // console.log("下拉变化事件1" + JSON.stringify(value) + "下标：");
     // console.log("下拉变化事件2" + value.position_code);
      this.conditions.houtpositioncode = value.positioncode;
      this.conditions.houtpositionname = value.positionname;
      this.positioncodes = value.positioncode;
      for (var i = 0; i < this.conditions.productList.length; i++) {
        this.conditions.productList[i].houtpositioncode = value.positioncode;
        this.conditions.productList[i].houtpositionname = value.positionname;
      }
      // this.getList();
      // this.selectProduct2();
    },
    selectchange2(value) {
     // console.log("下拉变化事件1" + JSON.stringify(value) + "下标：");
     // console.log("下拉变化事件2" + value.position_code);
      this.conditions.hinpositioncode = value.positioncode;
      this.conditions.hinpositionname = value.positionname;
      for (var i = 0; i < this.conditions.productList.length; i++) {
        this.conditions.productList[i].hinpositioncode = value.positioncode;
        this.conditions.productList[i].hinpositionname = value.positionname;
      }
      // this.getList();
    }, 
    choose(index) {
     // console.log("-=-=-=-=-=-=-打印下标" + index);
      this.productList2[index].checked = this.productList2[index].checked == '1' ? '0' : '1';
      for (var i = 0; i < this.productList2.length; i++) {
        if (i != index) {
          this.productList2[i].checked = '0'
          document.getElementById(i).style.backgroundColor = "#fff"
        }
      }
      if (this.productList2[index].checked == '1') {

        document.getElementById(index).style.backgroundColor = "#FFEFB7"
      } else {

        document.getElementById(index).style.backgroundColor = "#fff"
      }
      this.index2 = index;
    },
     choose2(index) {
     // console.log("-=-=-=-=-=-=-打印下标" + index);
      this.productList2[index].checked = this.productList2[index].checked == '1' ? '0' : '1';
      if(this.productList2[index].checked =='1'){
          var indexFlag = true;
          for(var j=0;j<this.index2List.length;j++){

              // this.index2List.forEach((item)=>{
                  if(this.index2List[j]==index){
                      indexFlag =false;
                  }
              // })
          }
         // console.log("打印indexFlag"+indexFlag);
          if(indexFlag){ 
              this.index2List.push(index);
          }
          // console.log("choose2打印this.index2List："+JSON.stringify(this.index2List));
      }else{
        for(var j=0;j<this.index2List.length;j++){

              // this.index2List.forEach((item)=>{
                  if(this.index2List[j]==index){
                      this.index2List.splice(j,1)
                  }
              // }) 
          } 
      }
      if (this.productList2[index].checked == '1') {

        document.getElementById(index).style.backgroundColor = "#FFEFB7"
      } else {

        document.getElementById(index).style.backgroundColor = "#fff"
      }
    },
    checkpro() {
     // console.log("_=-=-=-=-=" + this.index + "-=-=-=-=-=-" + this.index2);
      if (this.productList2[this.index2].checked != '1') {
            this.modelFlag = true;
            this.msgShow =false;
            this.methodName = 'message';
            this.msg = '请至少选择一件商品';
            this.butflag =false;
            this.butmsg='知道了';
        // this.$alert('请至少选择一件商品', '警告', {
        //   confirmButtonText: '确定'
        // });
      } else {
        var proflag = false;
        this.conditions.productList.forEach((item)=>{ 
            if(this.productList2[this.index2].materialname == item.materialname){
                proflag = true;
            }
        })
        if(proflag){
            this.modelFlag = true;
            this.msgShow =false;
            this.methodName = 'checkpro';
            this.msg = '该商品已存在！';
            this.butflag =false;
            this.butmsg='知道了';
        }else{
            //console.log("-=-==-=-=-=-=-打印商品信息" + JSON.stringify(this.productList2));
           // console.log("-=-==-=-=-=-=-this.index" +this.index);
            this.conditions.productList[this.index].materialname = this.productList2[this.index2].materialname;
            this.conditions.productList[this.index].materialcode = this.productList2[this.index2].materialcode;
            this.conditions.productList[this.index].wlspec = this.productList2[this.index2].wlspec;
            this.conditions.productList[this.index].wltype = this.productList2[this.index2].wltype;
            this.conditions.productList[this.index].cunitcode = this.productList2[this.index2].cunitcode;
            this.conditions.productList[this.index].cunitname = this.productList2[this.index2].cunitname;
            // this.conditions.productList[this.index].corigcurrencyid = this.productList2[this.index2].nprice;
            this.conditions.productList[this.index].ntaxratecode = this.productList2[this.index2].taxratecode;
            this.conditions.productList[this.index].ntaxratename = this.productList2[this.index2].taxratename;
            this.conditions.productList[this.index].suppliercode = this.productList2[this.index2].suppliercode;
            this.conditions.productList[this.index].suppliername = this.productList2[this.index2].suppliername;
            this.modelShow2 = false;
           // console.log("-=-==-=-=-=-=-打印商品信息" + JSON.stringify(this.conditions.productList[this.index]));
        }
      }
    },
    checkpro2() {
      // console.log("_=-=-=-=-=" + this.index + "-=-=-=-=-=-" + this.index2);
      var index2Flag = true;
      this.index2List.forEach((item)=>{
          if(this.productList2[item].checked == '1'){
              index2Flag = false;
          }
          // console.log("打印indexList："+item);
          // console.log("打印this.productList2[item].checked："+this.productList2[item].checked);
      });
      // console.log("打印this.index2List："+JSON.stringify(this.index2List));
      if (index2Flag) {
            this.modelFlag = true;
            this.msgShow =false;
            this.methodName = 'message';
            this.msg = '请至少选择一件商品';
            this.butflag =false;
            this.butmsg='知道了';
        // this.$alert('请至少选择一件商品', '警告', {
        //   confirmButtonText: '确定'
        // });
      } else {
        var proflag = false;
        // this.conditions.productList.forEach((item)=>{ 
        //     this.index2List.forEach((item2)=>{
        //        if(this.productList2[item2].materialname == item.materialname){
        //             proflag = true;
        //         }
        //    }); 
        // })
         for(var i=0;i<this.conditions.productList.length;i++){
              for(var j=0;j<this.index2List.length;j++){
                  // this.index2List.forEach((item2)=>{
                    // console.log("进入this.index2List.forEach打印");
                    // console.log("打印item2下标："+this.index2List[j]+"this.productList2[item2].materialname:"+this.productList2[this.index2List[j]].materialname);
                    // console.log("打印i下标："+this.index2List[j]+"this.conditions.productList[i].materialname:"+this.conditions.productList[i].materialname);

                     if(this.productList2[this.index2List[j]].materialname == this.conditions.productList[i].materialname){ 
                          proflag=true;
                          this.index2List.splice(j,1);
                      }
                     //  // if(this.productList2[item2].materialname == this.conditions.productList[i].materialname){
                     //      this.conditions.productList.splice(i,1);
                     //  }
                      
                 // }); 
              }
         }
            // console.log("-=-==-=-=-=-=-打印商品信息" + JSON.stringify(this.productList2));
            // console.log("-=-==-=-=-=-=-this.index" +this.index);
                var index2Listlength =this.index2List.length;
                var index2Listnum=1
                this.index2List.forEach((item3)=>{

                    this.conditions.productList[this.conditions.productList.length-1].materialname = this.productList2[item3].materialname;
                    this.conditions.productList[this.conditions.productList.length-1].materialcode = this.productList2[item3].materialcode;
                    this.conditions.productList[this.conditions.productList.length-1].wlspec = this.productList2[item3].wlspec;
                    this.conditions.productList[this.conditions.productList.length-1].wltype = this.productList2[item3].wltype;
                    this.conditions.productList[this.conditions.productList.length-1].cunitcode = this.productList2[item3].cunitcode;
                    this.conditions.productList[this.conditions.productList.length-1].cunitname = this.productList2[item3].cunitname;
                    // this.conditions.productList[this.index].corigcurrencyid = this.productList2[this.index2].nprice;
                    this.conditions.productList[this.conditions.productList.length-1].ntaxratecode = this.productList2[item3].taxratecode;
                    this.conditions.productList[this.conditions.productList.length-1].ntaxratename = this.productList2[item3].taxratename;
                    this.conditions.productList[this.conditions.productList.length-1].suppliercode = this.productList2[item3].suppliercode;
                    this.conditions.productList[this.conditions.productList.length-1].suppliername = this.productList2[item3].suppliername;
                    //console.log("this.conditions.productList.length-1"+(this.conditions.productList.length-1));
                    //console.log("index2Listnum<index2Listlength"+(index2Listnum<index2Listlength));
                    
                    if(index2Listnum<=index2Listlength){ 
                         this.addList();
                         index2Listnum+=1
                         // index2Listlength-=1;
                    }
                });
                this.modelShow2 = false;
                
                for(var g=0;g<this.productList2.length;g++){
                  this.productList2[g].checked=='0'
                  document.getElementById(g).style.backgroundColor = "#fff"
                }
                if(proflag){
                    this.$message({
                      showClose:true,
                      message:'已剔除选中的重复商品',
                      type:'succcess'
                    })
                }
      }
    },
    selectProduct2(){
      this.serchpro.storecode = this.user.storecode;
        this.serchpro.positioncode = this.conditions.houtpositioncode;
        this.serchpro.positionname = this.conditions.houtpositionname;
        this.serchpro.flag = 0;
        this.serchpro.pageflag = 1;
        this.serchpro.pageNum=this.propage;
        this.serchpro.pageSize=this.prosize;
        // this.serchpro.positionname=this.conditions.houtpositionname;
        //console.log("打印参数货位"+JSON.stringify(this.serchpro));
        this.$http.post(this.utilpath + '/PresentSock', this.serchpro, { emulateJSON: true,_timeout:600 }).then((result) => {
          // this.$http.post("/ktnapi/selectPresentSockForProduct",this.serchpro,{emulateJSON:true}).then((result) => {
          // this.$http.post(this.InterfacePath+"/selectAllSpdirectory",this.serchpro,{emulateJSON:true}).then((result) => {
          this.index2List =[];
          var res = result.data;
          if (res.status == '0') {
            this.productList2 = res.resultList;
            this.productName = this.serchpro.productName;
            this.productName = this.serchpro.productCode;
            if (this.serchpro.productName != '' || this.serchpro.productName != null||this.serchpro.productCode != '' || this.serchpro.productCode != null) {

              sessionStorage.setItem("productList2", JSON.stringify(this.productList2));
            }
            this.procount=res.countNum;
            //console.log("_+_+初始化打印商品信息_+_+_" + JSON.stringify(this.productList2));
          } else if (res.status == '-1') {
            this.productList2 =[];
            this.$message({
              showClose:true,
              message:'该仓库下暂无数据！',
              typr:'info'
            });
            //console.log("-----暂无数据！！！");
          } else if(res.data.status == '9'){
                this.$router.push({path:'/ui/login',query:{msg:9}});
        } else {
            this.modelFlag = true;
            this.msgShow = true;
            this.methodName = 'message';
            this.msg = res.message;
            this.butflag=false;
            this.butmsg='知道了';
            // this.$alert(res.message, '失败信息', {
            //   confirmButtonText: '确定'
            // });
          }
        }, (err) => {
          this.modelFlag = true;
          this.msgShow =false;
          this.methodName = 'message';
          this.msg = '调用查询商品目录接口失败';
          this.butflag =false;
          this.butmsg='知道了';
          // this.$alert('调用查询商品目录接口失败', '失败信息', {
          //   confirmButtonText: '确定'
          // });
          //console.log(err);
        });
      },
      oppro(num){
          this.modelShow2 = true;
          this.index = num == null ? this.index : num;
      },
    selectProduct(num) {
      //console.log("111111打印货位变换"+JSON.stringify(this.conditions));
      this.index = num == null ? this.index : num;
      var prod = JSON.parse(sessionStorage.getItem("productList2"));
      
      if (prod != null && this.serchpro.productName == this.productName &&this.serchpro.productCode == this.productCode &&this.serchpro.positioncode == this.positioncodes) {
        this.productList2 = prod;
      } 
      if (this.conditions.hinpositionname == '' || this.conditions.hinpositionname == null||this.conditions.houtpositionname == '' || this.conditions.houtpositionname == null) {
        this.modelShow2 = false;
        this.modelFlag = true;
        this.msgShow =false;
        this.methodName = 'message';
        this.msg = '请先选择调出和调入货位';
        this.butflag =false;
        this.butmsg='知道了';
        this.modelShow = false
        // this.$alert('请先选择调出货位', '失败信息', {
        //   confirmButtonText: '确定'
        // });
      } else {
        this.selectProduct2();
      };
    },
    getposition() {
      //获取数据接口
      var reqParam = {
        storecode: this.user.storecode
      };
      this.$http.post(this.utilpath + '/selectStorespositioninfo', reqParam, { emulateJSON: true ,_timeout:600}).then((res) => {
        // this.$http.post('/ktnapi/selectStorespositioninfo',reqParam,{emulateJSON:true}).then((res) => {
        // this.$http.post(this.InterfacePath+'/selectStorespositioninfo',reqParam,{emulateJSON:true}).then((res) => {
        if (res.data.status == '0') {
          var positions = res.data.resultList;
          //var positions=res.data.result;
          this.positionList = [];
          for (var i = positions.length - 1; i > -1; i--) {
            this.positionList.push({ positionname: positions[i].positionname, positioncode: positions[i].positioncode });
          }
          //console.log("打印货位" + JSON.stringify(this.positionList));
        } else if (res.data.status == '-1') {
            this.positionList = [];
            this.$message({
                showClose:true,
                message:'暂无数据',
                type:'info'
            })
        } else if(res.data.status == '9'){
                this.$router.push({path:'/ui/login',query:{msg:9}});
        } else {
          this.modelFlag = true;
          this.msgShow =false;
          this.methodName = 'message';
          this.msg = res.data.message + '+状态：' + res.data.status;
          this.butflag =false;
          this.butmsg='知道了';
          // this.$alert(res.data.message + '+状态：' + res.data.status, '失败信息', {
          //   confirmButtonText: '确定'
          // });
        }
        // console.log("获取的JSON数据"+JSON.stringify(res.result));       
      }, (err) => {
        this.modelFlag = true;
        this.msgShow =false;
        this.methodName = 'message';
        this.msg = '获取货位接口失败' + err;
        this.butflag =false;
        this.butmsg='知道了';
        // this.$alert('获取货位接口失败' + err, '失败信息', {
        //   confirmButtonText: '确定'
        // });
        console.log(err);
      });
    },
    init() {
      //sessionStorage.removeItem("weilist");
     // console.log("测试");
      this.user = JSON.parse(window.localStorage.getItem("userInfo"));
      var bigdata = JSON.parse(sessionStorage.getItem("weilist"));
      this.getposition();
      if (bigdata != null) {
        this.conditions = bigdata;
      } else {
        this.conditions.corpcode = this.user.corpcode;
        this.conditions.corpname = this.user.corpname;
        this.conditions.storeCode = this.user.storecode;
        this.conditions.storeName = this.user.storename;
        this.conditions.repertorycode = this.user.storehouse_code;
        this.conditions.repertoryname = this.user.storehouse_name;
        this.conditions.billmakercode = this.user.user_code;
        this.conditions.billmakername = this.user.user_name;
        this.conditions.productList[0].cinrepertorycode = this.user.storehouse_code;
        this.conditions.productList[0].cinrepertoryname = this.user.storehouse_name;

        // this.outposition.push(this.positionList[0]);
        // this.inposition.push(this.positionList[0]);
      }
     // console.log("sesson数据：" + sessionStorage.getItem("weilist"));
    },
    addList() { //添加明细
      var list = { 
        cinrepertorycode:this.user.storehouse_code,//调入仓库编码
        cinrepertoryname:this.user.storehouse_name,//调入仓库名称
        hinpositioncode: this.conditions.hinpositioncode, //调入货位编码
        hinpositionname: this.conditions.hinpositionname, //调入货位名称                   
        houtpositioncode: this.conditions.houtpositioncode, //调出货位编码
        houtpositionname: this.conditions.houtpositionname, //调出货位名称
        suppliercode: '', //供应商编码
        suppliername: '', //供应商名称
        materialcode: '', //物料编码
        materialname: '', //物料名称
        // wlspec: '',//规格
        // wltype: '',//型号
        cunitid: '', //主单位

        // vbatchcode: '',//批次号
        nnum: '', //调出数量
        memo:''//备注
      };
      this.conditions.productList.push(list);
      document.getElementById("tablescroll2").style.width = document.getElementById("topinp").offsetWidth + 'px';
      sessionStorage.setItem("weilist", JSON.stringify(this.conditions));
     // console.log("添加明细：" + sessionStorage.getItem("weilist"));
    },
    dellist(index, row) { //删除数据
      this.delindex = index
      this.methodName = 'delRow';
      this.msgShow =false;
      this.modelFlag = true;
      this.butflag = true;
      this.butmsg='确认';
      this.msg = '此操作将删除该行，是否继续？'
      // this.$confirm('此操作将删除该条数据，是否继续?', '提示', {
      //   confirmButtonText: '确定',
      //   cancelButtonText: '取消',
      //   type: 'warning'
      // }).then(() => {
      //   if (this.conditions.productList.length > 1) {
      //     this.conditions.productList.splice(index, 1);
      //   }
      //   sessionStorage.setItem("weilist", JSON.stringify(this.conditions));
      // }).catch(() => {
      //   this.$message({
      //     showClose: true,
      //     type: 'info',
      //     message: '已取消删除'
      //   });
      // });
    },
    selectchange(value) {
     // console.log("下拉变化事件1" + JSON.stringify(value) + "下标：");
    //  console.log("下拉变化事件2" + value.position_code);
      if (this.selectid == '1') {
        this.conditions.productList[this.tableListindex].houtpositioncode = value.position_code;
        this.conditions.productList[this.tableListindex].houtpositionname = value.position_name;
      } else {
        this.conditions.productList[this.tableListindex].hinpositioncode = value.position_code;
        this.conditions.productList[this.tableListindex].hinpositionname = value.position_name;
      }
      this.conditions.productList.forEach((item) => {
       // console.log("打印：" + JSON.stringify(item));
      });
      sessionStorage.setItem("weilist", JSON.stringify(this.conditions));
      this.modelShow = false;
    },
    //搜索框变化事件     
    onParamChange(index, msg) {
     // console.log("1111");
      sessionStorage.setItem("weilist", JSON.stringify(this.conditions));
    },
    numdown(num){
     // console.log("进来判断了");
        if(num<0){
          this.$message({
            showClose: true,
            message: '数量不能为负数！',
            type: 'error'
          });
        }
    },
    submit(formName) { //提交数据
      if (this.conditions.hinpositionname == '' || this.conditions.hinpositionname == null||this.conditions.houtpositionname == '' || this.conditions.houtpositionname == null) {
        this.modelFlag = true;
        this.msgShow =false;
        this.methodName = 'message';
        this.msg = '请先选择调出和调入货位';
        this.butflag =false;
        this.butmsg='知道了';
        this.modelShow2 = false
        // this.$alert('请先选择调出货位', '失败信息', {
        //   confirmButtonText: '确定'
        // });
      }else{
          this.$refs[formName].validate((valid) => {

        if (valid) {
         // console.log("进入！！！！！！！！！！！");
          var flag = true;
          var flag2 = false;
          var num = 0;
          var lastnum=this.conditions.productList.length-1
            if(this.conditions.productList[lastnum].materialcode==''||this.conditions.productList[lastnum].materialname==''||this.conditions.productList[lastnum].materialcode==null||this.conditions.productList[lastnum].materialname==null){
              if(lastnum!=0 ){

              this.conditions.productList.splice(lastnum,1)
              }
             //  console.log("删除多余行lastnum"+lastnum);
            }
            this.conditions.productList.forEach((item) => {
             // console.log("打印：this.conditions.productList.item"+JSON.stringify(item));
              ++num
              if (item.materialcode === '' || item.materialname === '' ||item.nnum === ''||item.nnum === null||item.hinpositioncode==''||item.houtpositioncode=='') {
                // console.log(num+"打印测试哪里没数据"+JSON.stringify(item))
                this.$message({
                  showClose: true,
                  message: '请将明细表填写完整！',
                  type: 'error'
                });
               // console.log("index:" + JSON.stringify(item));
                flag = false;
                return;
              }
              if(item.nnum<0){
                  flag2 = true;
              }
            });
            
          if (!flag&&!flag2) {
            return;
          }else if(flag2){
              this.$message({
                showClose: true,
                message: '数量不能为负数！',
                type: 'error'
              });
          } else if(flag) { 
           // console.log("打印最后提交数据："+JSON.stringify(this.conditions.productList));
            this.methodName = 'tiwei';
            this.modelFlag = true;
            this.msgShow =false;
            this.butflag = true;
            this.butmsg='确认';
            this.msg = '确认提交？';
          }
        } else {
          this.$message({
            showClose: true,
            message: '请将货位选择完毕！',
            type: 'error'
          });
         // console.log('error submit!!');
          return false;
        }
      });
    }
  }
      }
      
}

</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/stock/zengwei.vue